<script lang="ts" setup>
import { Plus, Minus } from "lucide-vue-next";

const colors = [
  "primary",
  "secondary",
  "accent",
];

const makeShuffledColorsFn = (n: number, m: number) => {
  // Build balanced list
  const list: number[] = [];
  for (let c = 0; c < m; c++) {
    const count = Math.floor(n / m) + (c < n % m ? 1 : 0);
    for (let i = 0; i < count; i++) list.push(c);
  }

  // Shuffle
  for (let i = list.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [list[i], list[j]] = [list[j], list[i]];
  }

  return (i: number) => colors[list[i]];
};

defineOptions({
  inheritAttrs: false,
});
const props = defineProps<{
  items: {
    title: string;
    description: string;
  }[];
  variant?: string;
  title?: string;
  description?: string;
  innerClass?: string;
}>();

const getColor = ref(makeShuffledColorsFn(props.items.length, colors.length));

const getCardStyle = (i: number) => {
  switch (props.variant) {
    case "outline":
      return "border last:border";
    case "multicolor":
      return `border-0 ${getColor.value(i)}`;
    case "primary":
    default:
      return "border-0 primary";
  }
};
</script>

<template>
  <SectionHeader :title="title" :description="description" />
  <div :class="innerClass">
    <Accordion type="single" collapsible class="w-full grid gap-2 grid-cols-1 md:grid-cols-2 lg:grid-cols-3" default-value="item-1">
      <AccordionItem
        v-for="(item, index) in items"
        :key="index"
        :value="`item-${index + 1}`"
        :class="`relative p-4 pb-12 data-[state=closed]:row-span-1 data-[state=open]:row-span-2 rounded-lg ${getCardStyle(index)}`"
      >
        <AccordionTrigger class="group/trigger">
          <template #icon>
            <div class="absolute bottom-4 right-4">
              <Plus
                class="pointer-events-none size-6 stroke-[3]
               group-data-[state=open]/trigger:hidden"
              />
              <Minus
                class="pointer-events-none size-6 stroke-[3]
               hidden group-data-[state=open]/trigger:block"
              />
            </div>
          </template>

          <div class="mx-auto text-center heading-4">
            {{ item.title }}
          </div>
        </AccordionTrigger>

        <AccordionContent class="space-y-2 text-center">
          <p
            v-for="(paragraph, pIndex) in item?.description?.split('\n')"
            :key="pIndex"
            class="paragraph-md"
          >
            {{ paragraph }}
          </p>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  </div>
</template>
